import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardContent from "../components/DashboardContent";
import ContactContent from "../components/ContactContent";
import { FiLogOut, FiMenu, FiX } from "react-icons/fi";

const DashBoardLayoutPage = () => {
  const [selectedSection, setSelectedSection] = useState("dashboard");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // controls sidebar on mobile
  const navigate = useNavigate();

  const renderContent = () => {
    switch (selectedSection) {
      case "dashboard":
        return <DashboardContent />;
      case "contact":
        return <ContactContent />;
      // case "blogs":
      //   return <BlogsContent />;
      default:
        return null;
    }
  };

  const handleLogout = () => {
    navigate("/");
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <aside
        className={`fixed z-40 top-0 left-0 h-full w-64 bg-[#0D283F] text-white shadow-md transform transition-transform duration-300 ease-in-out
        ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} 
        md:relative md:translate-x-0`}
      >
        <div className="p-6 flex flex-col justify-between h-full">
          {/* Top Section (Logo + Navigation) */}
          <div>
            <div className="flex flex-col items-center mb-8">
              <img src="/logo-with-name.webp" alt="Logo" className="h-16 w-32 object-contain" />
            </div>

            <nav className="flex flex-col space-y-4">
              {["dashboard", "contact"].map((section) => (
                <button
                  key={section}
                  onClick={() => {
                    setSelectedSection(section);
                    setIsSidebarOpen(false); // close sidebar on mobile
                  }}
                  className={`text-left px-4 py-2 rounded-md font-medium ${
                    selectedSection === section
                      ? "bg-white text-[#0C1832]"
                      : "hover:bg-white hover:text-[#0C1832]"
                  }`}
                >
                  {section.charAt(0).toUpperCase() + section.slice(1)}
                </button>
              ))}
            </nav>
          </div>

          {/* Bottom Logout Button */}
          <div>
            <button
              onClick={handleLogout}
              className="w-full flex items-center justify-center gap-2 bg-red-500 hover:bg-red-600 text-white py-2 px-2 rounded-md font-semibold transition duration-300"
            >
              <FiLogOut className="w-5 h-5" />
              Logout
            </button>
          </div>
        </div>
      </aside>

      {/* Overlay on small screens when sidebar is open */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black opacity-40 z-30 md:hidden"
          onClick={toggleSidebar}
        ></div>
      )}

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-y-auto">
        {/* Header with hamburger */}
        <header className="bg-white shadow-md p-4 flex items-center justify-between md:hidden">
          <button onClick={toggleSidebar} className="text-[#0C1832]">
            {isSidebarOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
          <h1 className="text-lg font-semibold text-[#0C1832]">Dashboard</h1>
          <div className="w-6" /> {/* Placeholder for spacing */}
        </header>

        <main className="p-4 md:p-8">{renderContent()}</main>
      </div>
    </div>
  );
};

export default DashBoardLayoutPage;
